import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'

@inject("mobxStore")
@observer
export class MapMarker extends Component {

  styleZ = (id, listingId) => {
    if (id === listingId) {
        return {zIndex: '10000'};
    }

    return {};
  }

  render () {
    const {listing} = this.props;
    const {mapMarkerShowId} = this.props.mobxStore;

    return (
        <Fragment>
            <div className="mapMarker" style={this.styleZ(mapMarkerShowId, listing.listingId)}>
                { mapMarkerShowId !== listing.listingId &&
                    <FontAwesomeIcon icon={faHome} />
                }
                { mapMarkerShowId === listing.listingId &&
                    <div>
                        <div style={{padding: '5px', cursor: 'pointer'}}>
                            <div>{listing.listingId}</div>
                            <div style={{fontWeight: 'bold'}}>{listing.currentPrice}</div>
                        </div>
                    </div>
                }
            </div>
            { mapMarkerShowId === listing.listingId &&
                <div style={{position: 'relative', bottom: '80px', left: '40px'}}>
                    <img alt={listing.listingId} src={listing.photo + '?w=140'} style={{border: '1px solid gray', borderRadius: '5px'}}/>
                </div>
            }
        </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MapMarker.jsx